import { render, staticRenderFns } from "./LandCompositionChart.vue?vue&type=template&id=01848fb6&scoped=true&"
import script from "./LandCompositionChart.vue?vue&type=script&lang=js&"
export * from "./LandCompositionChart.vue?vue&type=script&lang=js&"
import style0 from "./LandCompositionChart.vue?vue&type=style&index=0&id=01848fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01848fb6",
  null
  
)

export default component.exports